// Import hooks
import usePageTitle from "global/hooks/usePageTitle";

// Import components
import { Grid, GridItem } from "global/components/Grid";



// PodProductsPage.js
const CustomProductsPage = () => {



    // Set title inside the page
    usePageTitle("Custom Products");



    return (

        <>

            <Grid>

                <GridItem>

                    <p>Give options here for managaing custom products, MMMs and MMM links. Also in sub menus.</p>

                </GridItem>

            </Grid>

        </>

    );

};

export default CustomProductsPage;